import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';
import { useScrollToSection } from '../hooks/useScrollToSection';

/**
 * Floating scroll-to-top button that appears after scrolling down.
 * Replaces the static button in the Footer.
 */
export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const { scrollToTop } = useScrollToSection();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-14 h-14 rounded-full bg-slate-950 text-white shadow-xl border border-slate-800 flex items-center justify-center z-50 hover:bg-slate-800 transition-colors"
          aria-label="Volver arriba"
        >
          <ArrowUp className="h-6 w-6" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
